import Uploader from '../handler/Uploader';
import DragAndDrop from './DragAndDrop';

export const components = {
    DragAndDrop,
    Uploader,
};
